$(function () {

	$(document).on('click', '.icon_info, .icon-info, .span-info', function(event) {
		var $tooltip = $(this).find(".tooltip");
		$(".tooltip").not($tooltip).hide();

		if (!$tooltip.is(':visible')) {
			$(this).css({ 'user-select': 'inherit' });
			$tooltip.show();
		} else {
			$(this).css({ 'user-select': 'none' });
			$tooltip.hide();
		}

		event.stopPropagation();
	});

	$(document).on('click', '.icon_info .close, .icon-info .close, .span-info .close', function(e) {
		$(this).parent(".tooltip").hide();
		$(this).parent(".tooltip").parent('.icon_info').css({ 'user-select': 'none' });
		e.stopPropagation();
	});

	$(document).on('click', '.tooltip', function(event) {
		event.stopPropagation();
	});

	$(window).on('click', function () {
		$(".tooltip").hide();
    });

})